import { createSlice } from '@reduxjs/toolkit';
import { fetchDuluxPaletes } from '../actions/dulux-palete.action';
import { dulux, laNhaDulux } from '../../dataTest/dulux-palete';

// const getDuluxColorFromCookie = () => {
//   const palete = Cookies.get('dulux-palete');
//   if (palete) {
//     try {
//       return JSON.parse(palete);
//     } catch (error) {
//       return null;
//     }
//   }
//   return null;
// };

const initialState = {
  duluxPaletes: {
    data: dulux
      .map(item => ({
        ...item,
        colors: item.colors.filter(color =>
          laNhaDulux.some(lnDulux => color.color.name.includes(lnDulux))
        ),
      }))
      .filter(item => item.colors.length),
    isLoading: false,
    isNeedReloadData: false,
  },
};

export const duluxPaleteReducer = createSlice({
  name: 'DuluxPalete',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchDuluxPaletes.pending, state => {
        state.duluxPaletes = {
          ...state.duluxPaletes,
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchDuluxPaletes.fulfilled, (state, action) => {
        if (action.payload) {
          const { data } = action.payload;
          state.duluxPaletes = {
            ...state.duluxPaletes,
            data,
            isLoading: false,
          };

          // Cookies.set("dulux-palete", JSON.stringify(data));
        }
      });
  },
});

// export const {} = duluxPaleteReducer.actions;

export default duluxPaleteReducer.reducer;
